const getQuery = (name) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
  const search = window.location.href.split('?')[1]
  let r = null
  if (search) {
    r = search.match(reg)
  }
  if (r !== null) {
    return decodeURI(r[2])
  }
  return null
}

export default getQuery